import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './theme/primitives.css';
import './theme/semantic.css';
import './styles/reset.css';

import { initTelegram } from './telegram/init';
import { syncFromCloud } from './telegram/sync';
import { installCloudFlush } from './telegram/cloudStorage';
import { App } from './App';

async function bootstrap(): Promise<void> {
  // Подмена окружения только в dev — в прод-бандл ветка не попадает
  if (import.meta.env.DEV) {
    const { installMockEnv } = await import('./telegram/mockEnv');
    installMockEnv();
  }

  const root = document.getElementById('root');
  if (!root) throw new Error('#root не найден');

  // Рендер НЕ ждёт Telegram. Если мост недоступен (обычный браузер)
  // или какой-нибудь mount зависнет, пользователь всё равно увидит
  // интерфейс, а не пустую страницу. Все обращения к SDK внутри
  // компонентов защищены и работают как no-op до инициализации.
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );

  // Облако подтягиваем ПОСЛЕ первого рендера: локальная копия уже
  // показана, ждать сеть ради неё нельзя. Если данных нет или клиент
  // не поддерживает CloudStorage — просто ничего не произойдёт.
  installCloudFlush();
  void syncFromCloud();

  void initTelegram();
}

void bootstrap();
